import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/plastic.css'; // Assuming you are already using a custom CSS file


import Watch3 from '../assets/images/watch3.jpg';
import Watch4 from '../assets/images/watch4.jpg';
import Watch5 from '../assets/images/watch5.jpg';

const Watch = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Watch3,
    Watch3,
    Watch3,
    Watch4,
    Watch5,
   
  ];

  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div >
      <section className="about-container"> <h1>Smart Watch</h1></section>
      <br/><br/>
      <div className="acer-container">
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div></div>
  );
};

export default Watch;
